import React, { Component } from 'react';
import axios from 'axios';

import { AddTitle, UpdateTitle, AddBody, UpdateBody, AddSlider, UpdateBucketSlider } from '../shared/wakandaScenes';
import LoadSpinner from '../shared/loadSpinner';

/* Images */
import wakanda2 from '../../assets/wakanda2.jpg';
import wakanda4 from '../../assets/wakanda4.jpg';
import wakanda5 from '../../assets/wakanda5.jpg';

class Wakanda extends Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            budgetList:[],
            budgetStatus:"",
            budgetCreate:{
                name:"", payAmount:"", 
                payDt:null, freq:"biweekly", 
                savePercent:"", billList:[]
            },
            budgetActive:null,
            displaySlider: false,
            sliderType:"",
            selectedBill: { id:null, name:"", amount:"", payDt:"", gracePeriod: "", flexible: true },
            selectedBucketId: -2        
        }

        // References
        this.sliderRef = React.createRef();

        // Functions
        this.handleBudgetChange = this.handleBudgetChange.bind(this);
        this.handleBillChange = this.handleBillChange.bind(this);
        this.handleBillSwitch = this.handleBillSwitch.bind(this);
        this.chooseTitleImg = this.chooseTitleImg.bind(this);
        this.getSelectHeight = this.getSelectHeight.bind(this);
        this.toggleSlider = this.toggleSlider.bind(this);
        this.activateSlider = this.activateSlider.bind(this);
        this.saveBill = this.saveBill.bind(this);
        this.editBill = this.editBill.bind(this);
        this.removeBill = this.removeBill.bind(this);
        this.regenerateBucket = this.regenerateBucket.bind(this);

        this.getBudgetList = this.getBudgetList.bind(this);
        this.getBudget = this.getBudget.bind(this);
        this.saveBudget = this.saveBudget.bind(this);
        this.generateBudget = this.generateBudget.bind(this);
        this.regenerateBudget = this.regenerateBudget.bind(this);
    }

    handleBudgetChange(e){
        try {
            var tmpBudget = this.state.budgetCreate;  
            if("target" in e){
                var name = e.target.name;
                var value = e.target.value;
                tmpBudget[name] = value; 
            } 
            else {
                tmpBudget.payDt = e;
            }

           this.setState({ budgetCreate: tmpBudget });                          
        }
        catch(ex){
            console.log("[Error] handling form change data: ",ex);
        }
    }

    handleBillChange(e){
        try {
            var tmpBill = this.state.selectedBill;  
            
            var name = e.target.name;
            var value = e.target.value;
            tmpBill[name] = value; 

            this.setState({ selectedBill: tmpBill });             
        }
        catch(ex){
            console.log("Error handling form change data: ",ex);
        }
    }

    handleBillSwitch(status, e, id){
        try {
            var tmpBill = this.state.selectedBill;
            tmpBill[id] = status;

            this.setState({ selectedBill: tmpBill });
        }
        catch(ex){
            console.log(" [Error] handling switch change data: ",ex);
        }
    }

    chooseTitleImg(){
        try {
            switch(this.state.budgetStatus){
                case "add":
                    return wakanda5;                    
                case "update":
                    return wakanda4;                    
                default:
                    return wakanda2;
            }
        }
        catch(ex){
            console.log(" [Error] Choosing Title Image: ",ex);
        }
    }

    getSelectHeight(){
        var ret = -500;
        try {
            if((this.sliderRef.current && this.sliderRef.current !== null) || this.state.displaySlider){
                ret = (this.state.displaySlider ? 0 : (-1.0 * this.sliderRef.current.clientHeight));
            }
        }
        catch(ex){
            console.log("[Error] Getting Select Height: ",ex);
        }
        return ret;
    }

    toggleSlider(status){
        try {
            this.setState({ displaySlider: status,  selectedBill: { id:null, name:"", amount:"", payDt:"", gracePeriod: "", flexible: true } });
        }   
        catch(ex){
            console.log("[Error] Toggling Slider: ", ex);
        }
    }

    activateSlider(status, type){
        try {
            var tmpBudget = { name: this.state.budgetActive.name, payAmount: this.state.budgetActive.payAmount, 
                            freq: this.state.budgetActive.freq, savePercent: this.state.budgetActive.savePercent, 
                            payDt:(this.state.budgetActive.payDt ? new Date(this.state.budgetActive.payDt) : null),
                            _id: this.state.budgetActive._id, billList:[]};
            
            this.state.budgetActive.buckets.forEach(function(bucket){
                if(bucket.billList) {
                    tmpBudget.billList = tmpBudget.billList.concat(bucket.billList);
                }
            });
            
            this.setState({ displaySlider: status, sliderType: type, budgetCreate: tmpBudget })
        }
        catch(ex){
            console.log("[Error] Activate Slider: ", ex);
        }
    }

    saveBill(type, item, bucketId){
        var self = this;
        try {
            var tmpLoc; bucketIndex = 0;
            // Set Default Value
            if(item.gracePeriod === null || item.gracePeriod.length < 1){ item.gracePeriod = 7;}

            // Edit Bill Base On Type
            if(this.state.budgetStatus === "update"){
                if(bucketId > 0){
                    var bucketIndex = this.state.budgetActive.buckets.map(function(mID){ return mID.date; }).indexOf(bucketId);
                    tmpLoc = this.state.budgetActive.buckets[bucketIndex];

                    // Update Object
                    if(type === "update" && item.id !== null) {
                        var tmpIndex = tmpLoc.billList.map(function(e){ return e.id; }).indexOf(item.id);
                        if(tmpIndex >= 0) { tmpLoc.billList[tmpIndex] = item; }
                    }
                    else {
                        tmpLoc.billList.push(item);
                    }

                    tmpLoc.billList = tmpLoc.billList.sort(function(a,b){ return a.payDt - b.payDt; });

                    // Save Bill Based On Type
                    var tmpBudget = this.state.budgetActive;
                    tmpBudget.buckets[bucketIndex] = this.regenerateBucket(tmpLoc);

                    this.setState({ budgetActive: tmpBudget }, () =>{
                        if(self.state.budgetActive._id !== null) {
                            self.saveBudget();
                        }                        
                    });
                }
            }
            else { 
                tmpLoc = this.state.budgetCreate;

                // Update Object
                if(type === "update" && item.id !== null) {
                    var tmpIndex = tmpLoc.billList.map(function(e){ return e.id; }).indexOf(item.id);
                    if(tmpIndex >= 0) { tmpLoc.billList[tmpIndex] = item; }
                }
                else {
                    tmpLoc.billList.push(item);
                    tmpLoc.billList = tmpLoc.billList.sort(function(a,b){ return a.payDt - b.payDt; });
                }

                // Save Bill Based On Type
                this.setState({ budgetCreate: tmpLoc });
            }
        }   
        catch(ex){
            console.log("[Error] Adding Bill: ",ex);
        }
    }

    editBill(type, item, bucketId){
        try {
            item = (item === null ? { id:null, name:"", amount:"", payDt:"", gracePeriod: "", flexible:true } : JSON.parse(JSON.stringify(item)) );
            this.setState({ sliderType: type, selectedBill: item, selectedBucketId: bucketId, displaySlider: true });
        }   
        catch(ex){
            console.log("[Error] Edit Bill: ",ex);
        }
    }

    removeBill(id, bucketId){
        var self = this;
        try {
            var tmpLoc; bucketIndex = 0;

            // Edit Bill Base On Type
            if(this.state.budgetStatus === "update"){
                if(bucketId > 0){
                    var bucketIndex = this.state.budgetActive.buckets.map(function(mID){ return mID.date; }).indexOf(bucketId);
                    tmpLoc = this.state.budgetActive.buckets[bucketIndex];

                    // Remove bill
                    tmpLoc.billList = tmpLoc.billList.filter(function(item){ return item.id !== id; });

                    // Save Bill Based On Type
                    var tmpBudget = this.state.budgetActive;
                    tmpBudget.buckets[bucketIndex] = this.regenerateBucket(tmpLoc);    
                    this.setState({ budgetActive: tmpBudget }, () =>{
                        self.saveBudget();
                    });
                }
            }
            else { 
                tmpLoc = this.state.budgetCreate;

                // Remove bill
                tmpLoc.billList = tmpLoc.billList.filter(function(item){ return item.id !== id; });

                // Save Bill Based On Type
                this.setState({ budgetCreate: tmpLoc });
            }
        }   
        catch(ex){
            console.log("[Error] Removing Bill: ", ex);
        }
    }

    regenerateBucket(bucket){
        try {
            var tmpSpend = parseInt(this.state.budgetActive.payAmount, 10);
            var tmpPay = 0;
            var tmpGrace = bucket.gracePeriod;

            for(var i =0; i < bucket.billList.length; i++){
                tmpSpend = tmpSpend - parseInt(bucket.billList[i].amount, 10);
                tmpPay = tmpPay + parseInt(bucket.billList[i].amount, 10);
                if(bucket.billList[i].gracePeriod < tmpGrace) {
                    tmpGrace = bucket.billList[i].gracePeriod;
                }
            }
            
            bucket.spend = tmpSpend;
            bucket.total = tmpPay;
            bucket.gracePeriod = tmpGrace;
        }
        catch(ex){
            console.log("[Error] Regenerateing Bill Meta Data: ", ex);
        }

        return bucket;
    }

    getBudgetList(){
        var self = this;
        try {
            var user = this.props.checkUser(false,false);

            this.setState({ loading: true }, () =>{
                var getHeaders = { 'Content-Type': 'application/json', 'Authorization': user };

                axios.get(self.props.baseUrl + "/wakanda/retrieveAll", { headers: getHeaders })
                .then(function(response) {
                    if(response.data.error){
                        console.log(" [Error] Getting Budget List Results: ", response.data.error);
                        self.setState({ loading: false });
                    }
                    else {
                        var dataRet = response.data.results;                        
                        self.setState({ loading: false, budgetList: dataRet });
                    }
                });    
            });            
        }
        catch(ex){
            console.log(" [Error] Getting Budget List: ",ex);
        }
    }
    
    getBudget(budgetId){
        var self = this;
        try {
            this.setState({ loading: true, budgetStatus:"" }, () =>{
                var postData = { "budgetId": budgetId };

                axios.post(self.props.baseUrl + "/wakanda/retrieve", postData, {'Content-Type': 'application/json'})
                .then(function(response) {
                    if(response.data.error){
                        console.log(" [Error] Getting Budget: ", response.data.error);
                        self.setState({ loading: false });
                    }
                    else {
                        var dataRet = response.data.results;  
                        if(dataRet && dataRet.payDt){
                            dataRet.payDt = new Date(dataRet.payDt);
                        }
                                           
                        self.setState({ loading: false, budgetActive: dataRet, budgetStatus:"update" }, () =>{
                            self.getBudgetList();
                        });
                    }
                });    
            });

        }
        catch(ex){
            console.log(" [Error] Getting Budget: ",ex);
        }
    }

    saveBudget(){
        var self = this;
        try {
            var user = this.props.checkUser(false,false);

            this.setState({ loading: true }, () =>{
                var getHeaders = { 'Content-Type': 'application/json', 'Authorization': user };
                var postData = { "budget": this.state.budgetActive };

                axios.post(self.props.baseUrl + "/wakanda/save", postData, { headers: getHeaders })
                .then(function(response) {
                    if(response.data.error){
                        console.log(" [Error] Saving Budget: ", response.data.error);
                        self.setState({ loading: false });
                    }
                    else {
                        var dataRet = self.state.budgetActive;
                        dataRet._id = response.data.results;

                        self.setState({ loading: false, budgetActive: dataRet, budgetStatus:"update" }, () => {
                            self.getBudgetList();
                        });                        
                    }
                });    
            });
        }
        catch(ex){
            console.log(" [Error] Saving Budget: ",ex);
        }
    }

    regenerateBudget(){
        var self = this;
        try {

            if(self.state.budgetActive) { 
                var tmpData = self.state.budgetCreate;
                tmpData.billList = [];
                self.state.budgetActive.buckets.forEach(function(bucket){
                    if(bucket.billList) {
                        tmpData.billList = tmpData.billList.concat(bucket.billList);
                    }
                });
                
                self.setState({ budgetCreate: tmpData }, () => {
                    this.setState({ loading: true }, () =>{
                        var postData = self.state.budgetCreate;                
        
                        axios.post(self.props.baseUrl + "/wakanda/generate", postData, {'Content-Type': 'application/json'})
                        .then(function(response) {
                            if(response.data.error){
                                console.log(" [Error] Generating Budget: ", response.data.error);
                                self.setState({ loading: false });
                            }
                            else {
                                var dataRet = response.data.results;                        
                                self.setState({ loading: false, budgetActive: dataRet, budgetStatus:"update" }, () =>{
                                    self.saveBudget();
                                });
                            }
                        });    
                    });
                });
            }
        }
        catch(ex){
            console.log(" [Error] Regenerating Budget: ",ex);
        }
    }

    generateBudget(){
        var self = this;
        try {
            this.setState({ loading: true }, () =>{
                var postData = self.state.budgetCreate;                

                axios.post(self.props.baseUrl + "/wakanda/generate", postData, {'Content-Type': 'application/json'})
                .then(function(response) {
                    if(response.data.error){
                        console.log(" [Error] Generating Budget: ", response.data.error);
                        self.setState({ loading: false });
                    }
                    else {
                        var dataRet = response.data.results;                        
                        self.setState({ loading: false, budgetActive: dataRet, budgetStatus:"update" });
                    }
                });    
            });
        }
        catch(ex){
            console.log(" [Error] Generating Budget: ",ex);
        }
    }

    componentDidMount(){
        try {            
            this.getBudgetList();
        }
        catch(ex){
            console.log(" [Error] ",ex);
        }
    }

    render(){   
        return(
            <div className="page-container wakanda-page">
                {this.state.loading && <LoadSpinner userClass="wakanda" /> }
                <div className="btn-container">
                    <div className="tro-btn btn add" onClick={() => this.setState({ budgetStatus: "add" })}>
                        <div className="btn-txt">Add Budget</div>
                        <div className="btn-icon"><i className="fas fa-plus" /></div>
                    </div>

                    {this.state.budgetList.map((item,i) =>
                        <div className="tro-btn btn" key={i} onClick={() => this.getBudget(item._id)}>
                            <div className="btn-txt">{item.name}</div>
                            <div className="btn-icon"><i className="fas fa-coins" /></div>
                        </div>
                    )}
                </div>
                
                <div className={"page-panel title " + this.state.budgetStatus}>
                    <div className="title-content">
                        {this.state.budgetStatus == "" && <div className="no-data">Please Select A Current Budget Or Create A New One</div>}
                        {this.state.budgetStatus == "add" && <AddTitle budgetCreate={this.state.budgetCreate} handleChange={this.handleBudgetChange} />  }
                        {(this.state.budgetStatus == "update" && this.state.budgetActive !== null) && <UpdateTitle budgetActive={this.state.budgetActive} activateSlider={this.activateSlider} saveBudget={this.saveBudget} />  }
                    </div>
                    <img className="title-img" src={this.chooseTitleImg()} />
                </div>

                <div className="body-panel">
                    {this.state.budgetStatus == "add" && <AddBody budgetCreate={this.state.budgetCreate} editBill={this.editBill} removeBill={this.removeBill} generateBudget={this.generateBudget} />  }
                    {(this.state.budgetStatus == "update" && this.state.budgetActive !== null) && <UpdateBody budgetActive={this.state.budgetActive} editBill={this.editBill} removeBill={this.removeBill} />  }
                </div>

                {/* Sliding Panel */}
                <div className={"slider-container wakanda" + (this.state.displaySlider ? " open": "")} ref={this.sliderRef} style={{ bottom: this.getSelectHeight() }} >
                    {this.state.sliderType === "bill" && <AddSlider selectedBill={this.state.selectedBill} selectedBucketId={this.state.selectedBucketId} saveBill={this.saveBill} handleChange={this.handleBillChange} handleSwitchChange={this.handleBillSwitch} toggleSlider={this.toggleSlider}/> }
                    {this.state.sliderType === "budget" && <UpdateBucketSlider selectedBudget={this.state.budgetCreate} handleChange={this.handleBudgetChange} toggleSlider={this.toggleSlider} generateBudget={this.regenerateBudget} /> }
                </div>
            </div>
        );
    }
}

export default Wakanda;